import { render, staticRenderFns } from "./LsSection.vue?vue&type=template&id=8038698e&scoped=true&"
import script from "./LsSection.vue?vue&type=script&lang=ts&"
export * from "./LsSection.vue?vue&type=script&lang=ts&"
import style0 from "./LsSection.vue?vue&type=style&index=0&id=8038698e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8038698e",
  null
  
)

export default component.exports